import { FilterList } from "@mui/icons-material";
import {
  Badge,
  Button,
  Card,
  CardContent,
  Checkbox,
  Autocomplete,
  TextField,
  FormControl,
  FormControlLabel,
  FormGroup,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Modal,
  Paper,
  Select,
  Tooltip,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import axios from "../../CustomAxios";
import { debounce } from "lodash";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

function CustomerUserFilter({
  sortingField,
  sortingOrder,
  setFilter,
  setSortingField,
  setSortingOrder,
  customerCompany,
  setCustomerCompany,
  isDeleted,
  setIsDeleted,
}) {
  const [open, setOpen] = useState(false);
  const [count, setCount] = useState(0);
  const [customerCompaniesList, setCustomerCompaniesList] = useState([]);
  const [searchCustomerCompany, setSearchCustomerCompany] = useState("");

  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setOpen(false);
    setFilter(true);
  };

  const resetFilters = () => {
    setSortingField("");
    setSortingOrder("");
    setCustomerCompany("");
    setIsDeleted(false);
  };

  useEffect(() => {
    let totalCount = 0;

    if (sortingField) {
      totalCount++;
    }
    if (sortingOrder) {
      totalCount++;
    }
    if (customerCompany) {
      totalCount++;
    }
    if (isDeleted) {
      totalCount++;
    }

    setCount(totalCount);
  }, [sortingField, sortingOrder, customerCompany, isDeleted]);

  const fetchCompanies = async (search) => {
    try {
      const userData = JSON.parse(localStorage.getItem("AuthData"));
      const config = {
        headers: {
          Authorization: "Bearer " + userData.access_token,
        },
      };

      const url = `/api/v1/${userData?.type}/customer_company?limit=5&search_keyword=${search}`;

      const { data } = await axios.get(url, config);
      if (data.success) {
        setCustomerCompaniesList(data.data.data);
      }
    } catch (e) {
      console.log("error in fetching companies", e);
    }
  };

  const debouncedFetchCompanies = debounce((search) => {
    fetchCompanies(search);
  }, 300);

  useEffect(() => {
    fetchCompanies("");
  }, []);

  useEffect(() => {
    if (searchCustomerCompany) {
      debouncedFetchCompanies(searchCustomerCompany);
    } else {
      fetchCompanies("");
    }
  }, [searchCustomerCompany]);

  const authData = JSON.parse(localStorage.getItem("AuthData"));
  return (
    <Paper>
      <Tooltip title="Filters">
        <Badge badgeContent={count} color="error">
          <IconButton onClick={handleOpen} aria-label="Filters" size="small">
            <FilterList />
          </IconButton>
        </Badge>
      </Tooltip>
      <Modal open={open} onClose={handleClose}>
        <Card sx={style} style={{ width: "500px" }}>
          <CardContent>
            <Paper>
              <Grid container spacing={5}>
                {authData?.type !== "customer_user" ? (
                  <Grid item xs={12} md={12} lg={12}>
                    <Autocomplete
                      options={customerCompaniesList}
                      getOptionLabel={(option) => option.name}
                      filterOptions={(options, { inputValue }) => {
                        if (!inputValue) {
                          return options; // Show first 5 by default
                        }
                        const searchTerm = inputValue.toLowerCase();
                        return options.filter((option) =>
                          option.name.toLowerCase().includes(searchTerm)
                        );
                      }}
                      value={customerCompaniesList.find((c) => c._id === customerCompany) || null}
                      onChange={(e, newValue) =>
                        setCustomerCompany(newValue?._id || "")
                      }
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Customer Company"
                          placeholder="Search companies..."
                          variant="outlined"
                          onChange={(e) => setSearchCustomerCompany(e.target.value)}
                        />
                      )}
                      fullWidth
                      clearOnBlur={false}
                      sx={{
                        "& .MuiAutocomplete-listbox": {
                          maxHeight: 200,
                        },
                      }}
                      ListboxProps={{
                        style: {
                          maxHeight: "200px",
                        },
                      }}
                    />
                  </Grid>
                ) : null}
                <Grid item xs={12} md={12} lg={12}>
                  <FormControl fullWidth>
                    <InputLabel id="label">Select Sorting Field</InputLabel>
                    <Select
                      labelId="label"
                      fullWidth
                      id="label"
                      label="Select Sorting Field"
                      onChange={(e) => setSortingField(e.target.value)}
                      value={sortingField}
                    >
                      <MenuItem disabled value={""}>
                        Select Sorting Field
                      </MenuItem>
                      <MenuItem value="name">Name</MenuItem>
                      <MenuItem value="created_at">Created At</MenuItem>
                      <MenuItem value="updated_at">Updated At</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} md={12} lg={12}>
                  <FormControl fullWidth>
                    <InputLabel id="label">Select Sorting Order</InputLabel>
                    <Select
                      labelId="label"
                      fullWidth
                      id="label"
                      label="Select Sorting Order"
                      onChange={(e) => setSortingOrder(e.target.value)}
                      value={sortingOrder}
                    >
                      <MenuItem disabled value={""}>
                        Select Sorting Order
                      </MenuItem>
                      <MenuItem value="asc">Ascending</MenuItem>
                      <MenuItem value="desc">Descending</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} md={12} lg={12}>
                  <FormGroup fullWidth sx={{ ml: 1 }}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={isDeleted}
                          onClick={() => setIsDeleted(!isDeleted)}
                          color="error"
                        />
                      }
                      label="Show Deleted Customer Users"
                    />
                  </FormGroup>
                </Grid>
                <Grid item xs={12} md={6} lg={6}>
                  <Button onClick={resetFilters} color="error">
                    Reset All Filter
                  </Button>
                </Grid>
                <Grid
                  container
                  justifyContent={"flex-end"}
                  item
                  xs={12}
                  md={6}
                  lg={6}
                >
                  <Button onClick={handleClose} color="success">
                    OK
                  </Button>
                </Grid>
              </Grid>
            </Paper>
          </CardContent>
        </Card>
      </Modal>
    </Paper>
  );
}

export default CustomerUserFilter;
